var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',[_c('img',{attrs:{"src":_vm.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }